export default {
  page() {
    if (window.ga) {
      window.ga('set', 'page', window.location.pathname);
      window.ga('send', 'pageview');
    }
  },

  identify() {},

  async setProfileAndTimeout(context, profile) {
    await context.commit('setProfile', profile);
    context.commit('resetTimeout');
  },
};
